const MainConfigHome = () => import(/* webpackChunkName: "group-pabx-config" */ '../_views/MainConfigHome')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'geral',
    component: MainConfigHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Geral',
  },
]
